"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    en: {
        APPLICATION_INVALID: {
            label: 'Application invalid',
            labelBO: 'Application invalid (shine)',
        },
        APPLICATION_SUBMITTED: {
            label: 'Application submitted',
            labelBO: 'Application submitted (user)',
        },
        APPLICATION_VALIDATED: {
            label: 'Application validated',
            labelBO: 'Application validated (shine)',
        },
        COMPANY_REGISTERED: {
            label: 'Company registered',
            labelBO: 'Company registered (shine)',
        },
        FORM_COMPLETED: {
            label: 'Form completed',
            labelBO: 'Form completed (auto)',
        },
        OPTED_OUT: {
            label: 'Opted out',
            labelBO: 'Opted out (shine|user)',
        },
        PENDING: {
            label: 'Pending',
            labelBO: 'Pending (auto)',
        },
        REFUSED: {
            label: 'Refused',
            labelBO: 'Opted out (shine|auto)',
        },
        SENT_TO_STATE: {
            label: 'Sent to state',
            labelBO: 'Sent to state (shine)',
        },
    },
    fr: {
        APPLICATION_INVALID: {
            label: 'Dossier invalide',
            labelBO: 'Dossier invalide (shine)',
        },
        APPLICATION_SUBMITTED: {
            label: 'Dossier soumis',
            labelBO: 'Dossier soumis (user)',
        },
        APPLICATION_VALIDATED: {
            label: 'Dossier vérifié',
            labelBO: 'Dossier vérifié (shine)',
        },
        COMPANY_REGISTERED: {
            label: 'Entreprise créée',
            labelBO: 'Entreprise créée (auto)',
        },
        FORM_COMPLETED: {
            label: 'Formulaire complété',
            labelBO: 'Formulaire complété (auto)',
        },
        OPTED_OUT: {
            label: 'Abandon',
            labelBO: 'Abandon (shine|user)',
        },
        PENDING: {
            label: 'En cours',
            labelBO: 'En cours (auto)',
        },
        REFUSED: {
            label: 'Refusé',
            labelBO: 'Refusé (shine|auto)',
        },
        SENT_TO_STATE: {
            label: "Envoyé à l'État",
            labelBO: "Envoyé à l'État (shine)",
        },
    },
};
